import { createSelector } from 'reselect'

export const getTransportPointStates = state => state.transportPointStates.getIn(['all', 'objects'])

export const createGetTransportPointStateByIDSelector = id =>
    createSelector([getTransportPointStates], transportPointStates => transportPointStates.get(String(id)))
